// time picker

import Picker from 'pickerjs'

document.addEventListener('DOMContentLoaded', () => {
  const bodyObj = document.querySelector('body')

  const formFieldTime = document.querySelector('.form-field__time')
  const timeFormControl = document.querySelector('.time-form-control')
  const timePickerContainer = document.querySelector('.time-picker-container')

  if (formFieldTime && timeFormControl && timePickerContainer) {
    const timePicker = new Picker(document.querySelector('.form-field__time'), {
      container: '.time-picker-container',
      format: 'HH:mm',
      show(event) {
        const picker = event.target.picker.picker
        const pickerConfirm = picker.querySelector('.picker-confirm')

        if (!pickerConfirm.classList.contains('btn')) {
          pickerConfirm.classList.add('btn', 'btn-bounce', 'btn-bounce-primary')
        }

        // Добавляем класс открытого таймпикера
        timeFormControl.classList.add('time-picker-opened')
      },
      hidden() {
        // Удаляем класс при закрытии
        timeFormControl.classList.remove('time-picker-opened')
      },
      text: {
        confirm:
          '<span class="btn-text">Сохранить</span>' +
          '<span class="btn-icon">' +
          '<svg class="icon"><use xlink:href="/img/sprite.svg#icon-arrow-top-right"></use></svg>' +
          '</span>',
        cancel: 'Закрыть <svg class="close-icon"><use xlink:href="/img/sprite.svg#icon-close"></use></svg>',
      },
    })

    timeFormControl.addEventListener('click', (e) => {
      // Закрываем календарь перед открытием таймпикера
      $('.form-field__date').each(function () {
        const pickerInstance = $(this).pickadate('picker')
        if (pickerInstance && pickerInstance.get('open')) {
          pickerInstance.close()
        }
      })

      e.preventDefault()

      if (e.target.classList.contains('picker-picked') || e.target.classList.contains('btn-text')) {
        timePicker.pick()
        timePicker.hide()
      }

      if (e.target.classList.contains('close-icon')) {
        timePicker.hide()
      }
    })

    // Закрытие таймпикера при клике вне его области
    bodyObj.addEventListener('mousedown', (e) => {
      // Проверяем, если клик не по полю времени и не по открытому таймпикеру
      if (
        !e.target.closest('.time-form-control') &&
        !e.target.closest('.time-picker-container') &&
        !e.target.closest('.time-picker-opened')
      ) {
        if (timeFormControl.classList.contains('time-picker-opened')) {
          timePicker.hide()
        }
      }
    })
  }
})
